import React from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import ProtectedRoute from '@components/common/ProtectedRoute/ProtectedRoute';

import ActionItem from './pages/ActionItem/ActionItem';
import ActionItems from './pages/ActionItems/ActionItems';
import AiHistory from './pages/AiHistory/AiHistory';
import Archive from './pages/Archive/Archive';
import AssetHealthDetails from './pages/AssetHealthDetails/AssetHealthDetails';
import CostSavingsDetails from './pages/CostSavingsDetails/CostSavingsDetails';
import EquipmentDetails from './pages/EquipmentDetails/EquipmentDetails';
import Error404 from './pages/Error404/Error404';
import ExecutiveSummary from './pages/ExecutiveSummary/ExecutiveSummary';
import FailureCauseCategories from './pages/FailureCauseCategories/FailureCauseCategories';
import GPSAssetTracking from './pages/GPSAssetTracking/GPSAssetTracking';
import HardwareOverview from './pages/HardwareOverview/HardwareOverview';
import HardwareOverviewDetails from './pages/HardwareOverviewDetails/HardwareOverviewDetails';
import HelpAndResources from './pages/HelpAndResources/HelpAndResources';
import ManageEquipment from './pages/ManageEquipment/ManageEquipment';
import ManageFacility from './pages/ManageFacility/ManageFacility';
import ManageLocations from './pages/ManageLocations/ManageLocations';
import ManageTemplate from './pages/ManageTemplate/ManageTemplate';
import ManageTranslations from './pages/ManageTranslations/ManageTranslations';
import MultiplicationFactors from './pages/MultiplicationFactors/MultiplicationFactors';
import Profile from './pages/Profile/Profile';
import RedirectFromOldToNewAi from './pages/RedirectFromOldToNewAi/RedirectFromOldToNewAi';
import Reports from './pages/Reports/Reports';
import Root from './pages/Root/Root';
import SensorDetails from './pages/SensorDetails/SensorDetails';
import Sensors from './pages/Sensors/Sensors';
import SensorsList from './pages/SensorsList/SensorsList';
import SensorsTemperature from './pages/SensorsTemperature/SensorsTemperature';
import SiteEngagement from './pages/SiteEngagement/SiteEngagement';
import Users from './pages/Users/Users';
import WhatsNew from './pages/WhatsNew/WhatsNew';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <Error404 />,
    children: [
      {
        path: '/customer/:customerId',
        children: [
          {
            path: '',
            element: <ActionItems />,
          },
          {
            path: 'executive-summary',
            children: [
              {
                path: '',
                element: <ExecutiveSummary />,
              },
              {
                path: 'asset-health-details',
                element: <AssetHealthDetails />,
              },
              {
                path: 'cost-savings-details',
                element: <CostSavingsDetails />,
              },
              {
                path: 'failure-cause-categories',
                element: <FailureCauseCategories />,
              },
            ],
          },
          {
            path: 'ai/:actionItemId',
            children: [
              {
                path: '',
                element: <ActionItem />,
              },
              { path: 'history', element: <AiHistory /> },
            ],
          },
          {
            path: 'manage-locations',
            children: [
              {
                path: '',
                element: (
                  <ProtectedRoute>
                    <ManageLocations />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'location/:locationId',
                element: <ManageLocations />,
              },
            ],
          },
          {
            path: 'manage-translations',
            children: [
              {
                path: '',
                element: (
                  <ProtectedRoute>
                    <ManageTranslations />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'location/:locationId',
                element: <ManageTranslations />,
              },
            ],
          },
          {
            path: 'sensors',
            children: [
              {
                path: '',
                element: <Sensors />,
              },
              {
                path: ':locationId',
                element: <Sensors />,
              },
              {
                path: 'location/:locationId',
                element: <Sensors />,
              },
            ],
          },
          ///TODO: Temporary solution. Might need to be removed.
          {
            path: 'sensors-temperature',
            children: [
              {
                path: '',
                element: <SensorsTemperature />,
              },
            ],
          },
          {
            path: 'equipment-details',
            children: [
              {
                path: 'sensor/:pointId',
                element: <SensorDetails />,
              },
              {
                path: ':equipmentType/:itemId',
                element: <EquipmentDetails />,
              },
            ],
          },
          {
            path: 'sensors/:equipmentId/list',
            element: <SensorsList />,
          },
          {
            path: 'manage-equipment',
            children: [
              {
                path: '',
                element: (
                  <ProtectedRoute>
                    <ManageEquipment />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'location/:locationId',
                element: <ManageEquipment />,
              },
            ],
          },
          {
            path: 'hardware-overview',
            children: [
              {
                path: '',
                element: <HardwareOverview />,
              },
              {
                path: 'details',
                element: <HardwareOverviewDetails />,
              },
            ],
          },
          {
            path: 'reports',
            children: [
              {
                path: '',
                element: <Reports />,
              },
              {
                path: 'archive',
                element: <Archive />,
              },
              {
                path: 'site-engagement',
                element: <SiteEngagement />,
              },
            ],
          },
          {
            path: 'multiplication-factors',
            children: [
              {
                path: '',
                element: (
                  <ProtectedRoute>
                    <MultiplicationFactors />
                  </ProtectedRoute>
                ),
              },
              {
                path: 'manage-template/:templateId',
                element: <ManageTemplate />,
              },
            ],
          },
          {
            path: 'manage-facility',
            element: <ManageFacility />,
          },
          {
            path: 'users',
            element: <Users />,
          },
          {
            path: 'profile',
            element: <Profile />,
          },
          {
            path: 'help',
            element: <HelpAndResources />,
          },
          {
            path: 'whats-new',
            element: <WhatsNew />,
          },
          {
            path: 'gps-asset-tracking',
            element: <GPSAssetTracking />,
          },
        ],
      },
      //TODO: Temporary solution. Redirects to main from old dashboard urls
      {
        path: 'facility',
        children: [
          {
            path: '',
          },
          {
            path: ':facilityId',
            children: [
              {
                path: '',
                element: <Navigate to={'/'} />,
              },
              {
                path: ':redirectAiId',
                element: <RedirectFromOldToNewAi />,
              },
            ],
          },
        ],
      },
      {
        path: 'location',
        children: [
          {
            path: '',
          },
          {
            path: ':locationId',
            children: [
              {
                path: '',
                element: <Navigate to={'/'} />,
              },
              {
                path: ':redirectAiId',
                element: <RedirectFromOldToNewAi />,
              },
            ],
          },
        ],
      },
      {
        path: 'equipment',
        children: [
          {
            path: '',
            element: <Navigate to={'/'} />,
          },
          {
            path: ':equipmentId',
            element: <Navigate to={'/'} />,
          },
        ],
      },
      {
        path: 'translates',
        element: <Navigate to={'/'} />,
      },
      {
        path: 'asset-tree',
        element: <Navigate to={'/'} />,
      },
      {
        path: 'equipment-settings',
        element: <Navigate to={'/'} />,
      },
      {
        path: 'app',
        element: <Navigate to={'/'} />,
      },
    ],
  },
]);
